// extracted by mini-css-extract-plugin
export default {"title":"Activity_title__h3Kva"};